// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'

// import LoadingOverlay from './LoadingOverlay'
// const loadingComponent = new Vue({render: h => h(LoadingOverlay)}).$mount()
// document.getElementById('app').appendChild(loadingComponent.$el)

// Components
import './components'

// Plugins
import './plugins'
import vuetify from './plugins/vuetify'
// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import router from '@/router'
import getVuexStore from '@/store'
import VuePapaParse from 'vue-papa-parse'

//Auth checking
import { Logger } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import Auth from "@/services/Auth.js"

//load web component code
import Vuex from 'vuex'
import { injectScript } from '@/utils/vuex'
import { GetUserByEmail } from "@/services/API.js";
const logger = new Logger('MAIN.JS')

//global helpers
import { permissionsMix } from './mixins/permissions-helper.js'

Vue.mixin(permissionsMix)
Vue.use(VuePapaParse)
Vue.config.productionTip = false

window.LOG_LEVEL = process.env.NODE_ENV === 'development' ? 'DEBUG' : 'WARN'

let cmAuthToken = false
let goToken = false
let driverHoursProviderName = false
let telematicsProviderName = false
let driverHoursProviderUrl = false
let telematicsProviderUrl = false
let DashBoardUserId = false

//expose Vue, Vuex, Event Bus for web component
window.Vue = Vue
window.Vuex = Vuex
window.Plugins = { vuetify }
window.EventBus = AmplifyEventBus

// try to parse out any auth data sent from the GoPortal
try {
    const authData = JSON.parse(window.name)

    if(authData.camtoken && typeof authData.camtoken == 'string') {
        cmAuthToken = authData.camtoken
    }

    if(authData.gotoken && typeof authData.gotoken == 'string') {
        goToken = authData.gotoken
    }

    if(authData.DashBoardUserId && typeof authData.DashBoardUserId == 'string') {
        DashBoardUserId = authData.DashBoardUserId
    }

    if(authData.driverHoursProviderName && typeof authData.driverHoursProviderName == 'string') {
        driverHoursProviderName = authData.driverHoursProviderName
    }

    if(authData.telematicsProviderName && typeof authData.telematicsProviderName == 'string') {
        telematicsProviderName = authData.telematicsProviderName
    }

    if(authData.driverHoursProviderUrl && typeof authData.driverHoursProviderUrl == 'string') {
        driverHoursProviderUrl = authData.driverHoursProviderUrl
    }

    if(authData.telematicsProviderUrl && typeof authData.telematicsProviderUrl == 'string') {
        telematicsProviderUrl = authData.telematicsProviderUrl
    }
} catch {
    // no json parsable data in window.name, now we just continue with auth as normal
}


Auth.Refresh(cmAuthToken).then(async () => {

    const user = await Auth.currentAuthenticatedUser()
    const url = `${location.protocol}//${process.env.VUE_APP_lib_domain}/pvcam-wc.min.js`
    injectScript(url)
        .then(async () => {
            const res = await GetUserByEmail(user.email);
            const store = new Vuex.Store(
                getVuexStore({
                    orgs: [],
                    users: [],
                    vehiType: [],
                    email: user.email,
                    // if we have the service list property, split it out into an array of services :) 
                    serviceList: user['custom:services'].split(','),
                    sub: user.sub,
                    role: user['custom:role'],
                    [user.email]: res,
                    goToken: goToken,
                    driverHoursProviderName: driverHoursProviderName,
                    telematicsProviderName: telematicsProviderName,
                    driverHoursProviderUrl: driverHoursProviderUrl,
                    telematicsProviderUrl: telematicsProviderUrl,
                    DashBoardUserId: DashBoardUserId
                })
            )

            // Sync store with router
            sync(store, router)

            AmplifyEventBus.$emit("complete:pvcam-loading")
            new Vue({
                router,
                store,
                vuetify,
                render: h => h(App)
            }).$mount('#app')
        })
        .catch(err => {
            // eslint-disable-next-line no-console
            logger.error(err)
            confirm('somthing wrong, please refresh page')
        })

}).catch(err => {
    logger.debug(err)
    location.replace(location.protocol + '//' + process.env.VUE_APP_auth_domain)
})

